import { CalendarClock, Filter, Megaphone, Radio } from "lucide-react";

// Labels and limits of the Trigger tab. They mirror reminder_library/trigger/controller.js.

export const CODE_RE = /^[A-Z][A-Z0-9_]{1,49}$/;
export const PARAM_KEY_RE = /^[a-z][a-z0-9_]{0,39}$/;
export const MAX_GROUP_DEPTH = 4;
export const MAX_LEAVES = 50;
export const MAX_PARAMS = 20;
export const MAX_TAGS = 20;
export const DATE_TYPES = ["DATE", "TIMESTAMP"];

export const TRIGGER_TYPES = [
  { value: "CONDITION", label: "Condition", icon: Filter, hint: "Records that match now, e.g. overdue projects. A case closes when its record stops matching." },
  { value: "DATE_ANCHOR", label: "Date anchor", icon: CalendarClock, hint: "Counts from a date of the record, e.g. 3 days before a deadline, or every year on a date." },
  { value: "DOMAIN_EVENT", label: "Domain event", icon: Radio, hint: "Code announces an event (a status change); the reminder waits, then re-checks that record." },
  { value: "BROADCAST", label: "Broadcast", icon: Megaphone, hint: "No source: a scheduled message to an audience the rule picks." },
];

export const RECURRENCE_OPTIONS = [
  { value: "ONCE", label: "Once", hint: "The exact date (a deadline, a bid due date)." },
  { value: "ANNUAL", label: "Every year", hint: "Month and day only (an anniversary)." },
];

export const UNIT_LABEL = { MINUTE: "minutes", HOUR: "hours", DAY: "days" };
export const PARAM_TYPE_LABEL = { INT: "Whole number", NUMERIC: "Decimal", TEXT: "Text", DATE: "Date", BOOLEAN: "Yes / No" };
export const PARAM_TYPE_OPTIONS = Object.entries(PARAM_TYPE_LABEL).map(([value, label]) => ({ value, label }));
